import React, {useState} from "react";

// const TRIANGLE_RED = '#e778a8';
// const TRIANGLE_GREEN = '#4cd34c';
const TRIANGLE_RED = '#F84F31';
const TRIANGLE_GREEN = '#23c552';

const Rows = ({ rowData, index,onOpen,dataIndex,sheetType,soSelected,handleClickSQTable,RevCmptCheckList}) => {

        const [sSelected, setSSelected] = useState({
                label: false,
                labelType:"",
                desc: false,
                descType:""
        });

        const sheetReview = RevCmptCheckList !== undefined ? RevCmptCheckList.filter(sheet => sheet.uniqueCode === rowData.uniqueCode) : undefined;
        const sheetData1 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === 'label') : undefined;
        const sheetData2 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === 'desc') : undefined;
        let label;
        let labelType;
        let desc ;
        let descType ;

        if(sheetData2 !== undefined && sheetReview[sheetData2] !== undefined && sheetData2 > -1){
                desc = true;
                descType = sheetReview[sheetData2].cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN
        }else{
                desc = false;
        }
        if(sheetData1 !== undefined && sheetReview[sheetData1] !== undefined && sheetData1 > -1){
                label = true;
                labelType = sheetReview[sheetData1].cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN
        }else{
                label = false;
        }


        return <tr>
            <td style={{textAlign: "center"}}>{index+1}</td>
            <td title={rowData.seqCode}>
                {rowData.seqCode}
            </td>
            <td onClick={() => {
                //     onOpen({name:"label"},rowData.uniqueCode);
                //     handleClickSQTable("label",index);
            }}
            style={{cursor:"pointer",overflow:"hidden",position: "relative",background: soSelected.name === "label" && soSelected.index === index ? "#eee" : "transparent"}}>
                    {/* {label? <div style={{position: "absolute", backgroundColor: labelType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""} */}
                    <span>{rowData.label}</span>
            </td>
            <td onClick={() =>{
                    onOpen({name:"desc"},rowData.uniqueCode)
                    handleClickSQTable("desc",index);
            }}
                style={{cursor:"pointer",overflow:"hidden",position: "relative",background: soSelected.name === "desc" && soSelected.index === index ? "#eee" : "transparent"}}>
                    {desc? <div style={{position: "absolute", backgroundColor: descType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                    <span>{rowData.desc}</span>
            </td>
            <td style={{textAlign: "center"}}>
                {rowData.repeat}
            </td>
            <td className="cancle"></td>
        </tr>
    
}

const onOpen = (index, name) => {
        const tData = [];
        const target = tData.find(tdValue => tdValue.soSeq === index && tdValue.label === name);
        const newTarget = {...target, active: true}
}

export default Rows;
